import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { Copy } from 'lucide-react';

interface CloneProposalDialogProps {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

/** Confirmação do clone de proposta PME. */
export function CloneProposalDialog({
  isOpen,
  isLoading = false,
  onClose,
  onConfirm,
}: CloneProposalDialogProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[640px] max-w-[90vw] rounded-[24px] bg-[#F9F9F9] p-0 shadow-xl'>
          <div className='flex flex-col items-start gap-4 p-6'>
            <Dialog.Header className='w-full p-0'>
              <Dialog.Title className='w-full'>
                <div className='flex w-full items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <Copy className='h-6 w-6 text-alba-black-500' />
                    <Text className='text-lg font-bold text-alba-black-500'>
                      Clonar proposta
                    </Text>
                  </div>
                  <Dialog.CloseButton onClick={onClose} />
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='w-full p-0'>
              <div className='flex flex-col items-start gap-2 w-full'>
                <Text className='text-sm text-alba-gray-600'>
                  Deseja clonar esta proposta?
                </Text>
                <Text className='text-sm text-alba-gray-600'>
                  Uma nova proposta será criada em digitação a partir desta. O
                  plano (modalidade, capitais e coberturas) ficará bloqueado na
                  proposta clonada; data de vencimento, comissionamento e vidas
                  poderão ser alterados.
                </Text>
              </div>
            </Dialog.Body>

            <Dialog.Footer className='w-full p-0'>
              <div className='flex w-full items-center justify-end gap-6'>
                <Dialog.CloseTrigger asChild>
                  <Button variant='ghost' size='large'>
                    Cancelar
                  </Button>
                </Dialog.CloseTrigger>
                <Button
                  variant='primary'
                  size='large'
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={onConfirm}
                >
                  Confirmar
                </Button>
              </div>
            </Dialog.Footer>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
